module.exports = __webpack_public_path__ + "img/logo-seplag.c4dbf865.png";